import { render } from "./branch.vue?vue&type=template&id=6a32d855&scoped=true"
import script from "./branch.vue?vue&type=script&lang=js"
export * from "./branch.vue?vue&type=script&lang=js"

import "./branch.vue?vue&type=style&index=0&id=6a32d855&lang=scss&scoped=true"
import "./branch.vue?vue&type=style&index=1&id=6a32d855&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a32d855"]])

export default __exports__